// React
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Custom hook to clean URLs from "null" values
 * Handles cleaning of hostname, localStorage, and pathname
 */
export const useUrlCleaner = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Check if null is in the hostname
    if (window.location.hostname.includes("null.")) {
      // Remove null from hostname and redirect
      const newHostname = window.location.hostname.replace("null.", "");
      const newUrl = `${window.location.protocol}//${newHostname}${window.location.port ? `:${window.location.port}` : ""
        }${window.location.pathname}${window.location.search}${window.location.hash}`;
      window.location.href = newUrl;
      return;
    }

    // Check and clean localStorage subdomain
    const storedSubdomain = localStorage.getItem("subdomain") || null;
    if (storedSubdomain === "null" || storedSubdomain === null) {
      localStorage.clear();
    }

    // Also check pathname for null (keep existing logic)
    if (location.pathname.includes("null")) {
      navigate(location.pathname.replace("null.", ""));
    }
  }, [location, navigate]);
};

export default useUrlCleaner;
